(function($) {
	
	$('.esrb-form select').select2();

	// Select2 names its combobox only after the currently rendered value, so the field's own
	// label ("Time Frame") was never announced. Carry the native select's aria-labelledby
	// across, keeping Select2's reference so the current value is still read out after it.
	$('.esrb-form select').each(function() {
		var labelledby = this.getAttribute('aria-labelledby');
		var $selection = $(this).next('.select2-container').find('.select2-selection');

		if (labelledby && $selection.length) {
			$selection.attr('aria-labelledby', $.trim(labelledby + ' ' + ($selection.attr('aria-labelledby') || '')));
		}
	});

})(jQuery);